export function LoadingPageContent() {
  // not sure yet
  return <div data-testid="client-intro-state--loading" />;
}
